import moment from "moment";
import { VIDEO_UPLOAD } from "../Constants/types";
import { CRM_TABS } from "../screens/BespokeCRMTabs/constants";
import { livetools } from "../Constants/livetools";
import Firebase from "../firebasehelper";
import { brandMapping } from "./Constants";

export const CommaSeparateValue = (value) =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const nFormatter = (num, digits) => {
  var si = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
};

export function getYoutubeId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
}

const offensiveWords = [
  "arse",
  "arsehead",
  "arsehole",
  "ass",
  "asshole",
  "Balls",
  "Bastard",
  "Bellend",
  "Bint",
  "Bitch",
  "Bloodclaat",
  "bloody",
  "Bollocks",
  "brotherfucker",
  "bugger",
  "Bullshit",
  "C**t",
  "Clunge",
  "Cock",
  "cocksucker",
  "crap",
  "Cunt",
  "damn",
  "damn it",
  "Dick",
  "Dickhead",
  "dyke",
  "F**k",
  "Fanny",
  "Feck",
  "frigger",
  "Fuck",
  "fuck",
  "Gash",
  "Gay",
  "goddamn",
  "godsdamn",
  "hell",
  "holy shit",
  "Homo",
  "horseshit",
  "in shit",
  "Jesus Christ",
  "Jesus fuck",
  "kike",
  "Knob",
  "Minge",
  "Motherf**ker",
  "motherfucker",
  "Munter",
  "nigga",
  "nigra",
  "nonse",
  "piss",
  "Pissed",
  "Prick",
  "Punani",
  "Pussy",
  "Retard",
  "Shit",
  "shite",
  "slut",
  "Snatch",
  "Son of a bitch",
  "spastic",
  "sweet Jesus",
  "Tits",
  "turd",
  "Twat",
  "wanker",
  "Wigger",
];

export const hasOffensiveWords = (obj) => {
  const textContents = Object.values(obj);
  for (let i = 0; i < textContents.length; i++) {
    if (typeof textContents[i] === "string") {
      for (let j = 0; j < offensiveWords.length; j++) {
        if (
          textContents[i]
            .toLowerCase()
            .includes(offensiveWords[j].toLowerCase())
        ) {
          return true;
        }
      }
    }
  }
  return false;
};

export const addDigitDelimiter = (num) => {
  let out = "";
  let numInts = 0;

  while (num > 0) {
    if (numInts > 0 && numInts % 3 === 0) out = `,${out}`;
    const digit = Math.floor(num % 10);
    out = `${digit}${out}`;
    num = Math.floor(num / 10);
    numInts++;
  }
  return out;
};

export const formatDate = (timestamp) => {
  return moment.unix(timestamp).format("MMMM Do YYYY, h:mm a");
};

// chat timestamps
export const formatTimestamp = (timestamp) => {
  return moment(Number(timestamp)).calendar(null, {
    // when the date is closer, specify custom values
    lastWeek: "[Last] dddd[,] LT",
    lastDay: "[Yesterday,] LT",
    sameDay: "[Today,] LT",
    sameElse: "DD/MM/YYYY[,] LT",
  });
};

export const getFilePath = (folderName, url, mediaType, includeName = true) => {
  // FIXME: this should be simplified where possible
  let path;
  if (mediaType === VIDEO_UPLOAD) {
    path = url
      .replaceAll("%2F", "/")
      .replaceAll("%20", " ")
      .split("?")[0]
      .split("/o/")[1];
  } else {
    const splitPath = url.split("%2F");

    const subFolder = splitPath[1];
    const subFolderTwo = splitPath[2];

    const nameWithParams = splitPath[splitPath.length - 1];
    const assetName = nameWithParams.split("?")[0];

    path = `${folderName}/${subFolder}${
      subFolderTwo ? `/${subFolderTwo}` : ""
    }${includeName ? `/${assetName}` : ""}`;
  }
  return `/${path}`;
};

export const populateMissingTabs = (crmTabs) => {
  const isMissingTabs = crmTabs
    ? Object.keys(crmTabs).length < CRM_TABS.length
    : true;
  if (!isMissingTabs) return crmTabs;

  let updatedTabs = { ...crmTabs };
  CRM_TABS.forEach((tab) => {
    if (!updatedTabs[tab] || updatedTabs[tab] !== false)
      updatedTabs[tab] = true;
  });
  return updatedTabs;
};

export const isUnbrandedSite = () => {
  return (
    window.location.hostname.toLowerCase().includes("ecosystem") ||
    process.env.NODE_ENV === "development"
  );
};

export const getDefaultPermissions = () => {
  let allPermissions = [];

  Object.keys(livetools).forEach((group) => {
    livetools[group]["tabs"].forEach((tab) => {
      allPermissions.push(tab.name);
    });
  });
  return allPermissions;
};

export const populateMissingPermissions = (brandPermissions) => {
  const DEFAULT_PERMISSIONS = getDefaultPermissions();
  const brandKeys = Object.keys(brandPermissions || {});

  const isMissingPermissions = brandKeys.length < DEFAULT_PERMISSIONS.length;
  if (!isMissingPermissions) return brandPermissions;

  let populatedPermissions = { ...brandPermissions };
  DEFAULT_PERMISSIONS.forEach((permission) => {
    if (!(permission in populatedPermissions))
      populatedPermissions[permission] = true;
  });
  return populatedPermissions;
};

export const getallLandingOptions = (brandName) => {
  const optionsToSkip = new Set([
    "tickets",
    "messages",
    "reviews",
    "iframe",
    "saving",
  ]);

  let allLandingOptions = [];
  Object.keys(livetools).forEach((group) => {
    livetools[group]["tabs"].forEach((tab) => {
      if (!optionsToSkip.has(tab.name)) {
        allLandingOptions.push({
          value: tab.path,
          label: tab.name === "shop" ? `${brandName}'s Marketplace` : tab.title,
        });
      }
    });
  });
  return allLandingOptions;
};

export const setFaviconAndTitle = async () => {
  const hostName = window.location.hostname.toLowerCase();
  const brandInfo = brandMapping.find((brand) =>
    hostName.includes(brand.substring)
  );

  if (brandInfo) {
    // set doc title
    document.title = brandInfo.title;

    // get icon
    const faviconUrl = await Firebase.getBrandIconByID(brandInfo.brandId);

    // set icon as favicon
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.href = faviconUrl;
    document.getElementsByTagName("head")[0].appendChild(link);
  }
};

export const getFileBase64 = (input) => {
  return new Promise((resolve, reject) => {
    let content;

    // Determine if input is a React SyntheticEvent or a File
    if (input && input.target && input.target.files && input.target.files[0]) {
      content = input.target.files[0];
    } else if (input instanceof File) {
      content = input;
    } else {
      reject(new Error("Invalid input type. Expected Event or File."));
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(content);
  });
};

export const hexToRgb = (hex) => {
  // Remove the '#' character if present
  hex = hex.replace(/^#/, "");

  // Extract the RGB components
  let r, g, b, a;
  if (hex.length === 6) {
    // Regular RGB hex code (no alpha channel)
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
    a = 1; // Default alpha channel value
  } else if (hex.length === 8) {
    // RGBA hex code (with alpha channel)
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
    a = parseInt(hex.substring(6, 8), 16) / 255; // Convert alpha channel value to a decimal between 0 and 1
  } else {
    throw new Error("Invalid hexadecimal color code");
  }

  // Return the RGB components as an object
  return { r, g, b, a };
};

export const splitSentence = (sentence, maxLength = 25) => {
  const words = sentence.split(" ");
  const lines = [];
  let currentLine = "";

  words.forEach((word) => {
    // Check if adding the next word would exceed the maxLength
    if (currentLine.length + word.length + 1 <= maxLength) {
      if (currentLine.length > 0) {
        currentLine += " " + word;
      } else {
        currentLine = word;
      }
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  });

  // Add the last line
  if (currentLine.length > 0) {
    lines.push(currentLine);
  }

  return lines;
};

export const formatPriceInput = (amount) => {
  if (!amount) return "";
  return amount / 100;
};

export const formatToTitleCase = (inputString) => {
  return `${inputString[0].toUpperCase()}${inputString.slice(1)}`;
};

export const uploadFile = async (file, path) => {
  const title = new Date().getTime().toString();

  try {
    const assetUrl = await Firebase.uploadFile(file, title, path);
    return assetUrl;
  } catch (e) {
    console.error("fileUpload", e);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/Utils/utils.js